import * as React from 'react'
import './index.css'
import { dateFormat } from '../../util'
import * as moment from 'moment'

class TimeLine extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            currentExperience: []
        }
    }

    componentDidMount() {
        const {Author} = this.props
        //  filter newest 5 data
        let newData = Author
        if (Author.length > 4) {
            newData = Author.slice(Author.length - 4, Author.length)
        }
        let temp = []
        let length = Author.length
        for (let i = 0; i < 4 - length; i++) {
            newData.unshift(
                {
                    id: length + i
                }
            )
        }
        for (let i = 0; i < newData.length; i++) {
            if (newData[i].grant_date) {

                let date = dateFormat(newData[i].grant_date)
                temp.push(
                    {id: -1}
                )
                temp.push(
                    {
                        ...newData[i],
                        grant_date: date
                    }
                )
            } else {
                temp.push(
                    {id: -1}
                )
                temp.push(
                    {
                        ...newData[i],
                    }
                )
            }
        }
        this.setState(
            {
                currentExperience: temp
            }
        )
    }

    getExperience(item: any, index: any) {
        return (
            <div key={index} className={(index + 1) % 4 === 0 ? 'event1' : 'event2'}>
                {item.grant_date &&
                <div className={(index + 1) % 4 === 0 ? 'event1Bubble' : 'event2Bubble'}>
                    {
                        item.grant_date &&
                        <div className="eventTime">
                            <div className="Day">
                                {moment(item.grant_date).format('YYYY.MM.DD')}
                            </div>
                        </div>
                    }
                    {
                        item.comp_name &&
                        <div className="Day">
                            {item.comp_name}
                        </div>
                    }
                    {
                        item.title &&
                        <div className="eventTitle">{item.title}</div>
                    }
                    {
                        item.sec_id &&
                        <div className="Day">{item.sec_id}</div>
                    }
                </div>
                }
                {
                    item.status &&
                    <div className="eventAuthor">{item.status === '正常' ? '在职' : item.status}</div>
                }
                <svg height="20" width="20">
                    <circle cx="10" cy="11" r="5" fill="#004165"/>
                </svg>
                {/*<div className="time">9 : 27 AM</div>*/}
            </div>
        )
    }

    getLine(index: any) {
        return (
            <div key={index} className="line-1"/>
        )
    }

    render() {
        return (
            <div className="Timeline">
                {
                    this.state.currentExperience && this.state.currentExperience.length > 0 && this.state.currentExperience.map((item: any, index: any) =>
                        item.id === -1 ? this.getLine(index)
                            :
                            this.getExperience(item, index)
                    )
                }
                <div className="line-1"/>
            </div>
        )
    }
}

export default TimeLine



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TimeLine/index.tsx